<script>
import axios from 'axios';
import API from '@/services/API.js';
import Utils from "@/services/utils.js";

import Button2 from "@/components/ui/Button2.vue";
import SuperTable from "@/components/ui/Table";

export default {
    name: 'ActionsLicencesModal',
    components: {
        Button2,
        SuperTable
    },
    props: {
        itemCount: {
            type: Number
        },
        type: {
            type: String,
            validator(value) {
                return ['cancel', 'resend'].includes(value)
            }
        },
        selectedLicences: {
            type: Array
        }
    },
    data: () => ({
        loading: false,
        licences: undefined,
        statusMap: {
            0: Utils.t('device.registrations.details_modal.licence_statuses.available'),
            1: Utils.t('device.registrations.details_modal.licence_statuses.sent'),
            2: Utils.t('device.registrations.details_modal.licence_statuses.associated'),
            3: Utils.t('device.registrations.details_modal.licence_statuses.expired')
        },
        tableColumns: {
            global: {
                sortable: false,
                noItemsMsg: Utils.t('device.registrations.emptyTable')
            },
            columns: [
                {
                    key: 'id',
                    label: Utils.t('device.registrations.licence'),
                    showPopup: false,
                    activeFilter: '',
                    activeSort: false,
                    sortable: false,
                },
                {
                    key: 'name',
                    label: Utils.t('device.registrations.details_modal.columns.lone_worker'),
                    showPopup: false,
                    activeFilter: '',
                    activeSort: false,
                    sortable: false,
                }, 
                {
                    key: 'recipient',
                    label: Utils.t('device.registrations.details_modal.columns.phone_number'),
                    showPopup: false,
                    activeFilter: '',
                    activeSort: false,
                    sortable: false,
                },
                {
                    key: 'status',
                    label: Utils.t('device.registrations.details_modal.columns.status'),
                    showPopup: false,
                    activeFilter: '',
                    activeSort: false,
                    sortable: false,
                },
                {
                    key: 'type',
                    label: Utils.t('device.registrations.details_modal.columns.type'),
                    showPopup: false,
                    activeFilter: '',
                    activeSort: false,
                    sortable: false,
                }
            ],
            rowActions: {}
        }
    }),
    methods: {
        loadDetails: function() {
            this.loading = true;
            
            const endpoint = this.type == "cancel" ? API.endpoints.licences.mass.cancel_details : API.endpoints.licences.mass.resend_details
            axios.post(endpoint, {list_licence: this.selectedLicences.map(item => item.id) })
                .then((response) => {
                    this.licences = response.data.message.map(licence => ({
                        id: Utils.formatLicenceId(licence.dati_id),
                        name: licence.dati_name,
                        recipient: licence.recipient,
                        type: licence.recipient ? Utils.t('device.registrations.details_modal.type.sms') : Utils.t('device.registrations.details_modal.type.qrcode'),
                        status: this.statusMap[licence.status]
                    }))
                })
                .catch(error => console.log(error))
                .finally(() => {
                    this.loading = false;
                })
        }
    }
}
</script>

<template>
    <div class="ActionsLicencesModal p-3 w-100">
        <div class="my-2" v-html="$tc(`device.registrations.${type}_licences.count`, itemCount, {count: itemCount})"></div>
        <div class="my-3" v-html="$t(`device.registrations.${type}_licences.info`)"></div>

        <Button2 
            class="btn-sm my-2"
            :disabled="loading || licences !== undefined"
            @click.native.prevent="loadDetails"
        >
            {{ $t(`device.registrations.details_modal.get_details`) }}
            <div v-if="loading" class="spinner-border spinner-border-sm ml-2" role="status">
                <span class="sr-only">{{ $t("global.loading") }}</span>
            </div>
        </Button2>

        <div v-if="licences !== undefined">
            <SuperTable
              :tableColumns="tableColumns"
              :tableData="licences"
              :loading="loading"
            />
        </div>
    </div>
</template>
